import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../mockData';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Ana Sayfa', path: '/' },
    { name: 'Hakkımızda', path: '/hakkimizda' },
    { name: 'Şirketlerimiz', path: '/sirketlerimiz' },
    { name: 'Tohumculuk', path: '/tohumculuk' },
    { name: 'Ürünler', path: '/urunler' },
    { name: 'Blog', path: '/blog' },
    { name: 'İletişim', path: '/iletisim' }
  ];

  return (
    <>
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-[#4A7C3A] to-[#8AC73E] text-white py-2">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center text-sm">
            <div className="flex items-center space-x-6">
              <a href={`tel:${companyInfo.phone}`} className="flex items-center space-x-2 hover:text-white/80 transition-colors">
                <Phone size={14} />
                <span className="hidden md:inline">{companyInfo.phone}</span>
              </a>
              <a href={`mailto:${companyInfo.email}`} className="flex items-center space-x-2 hover:text-white/80 transition-colors">
                <Mail size={14} />
                <span className="hidden md:inline">{companyInfo.email}</span>
              </a>
            </div>
            <div className="text-xs md:text-sm">
              <span className="font-medium">Şanlıurfa'nın Tarımsal Gücü</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header
        className={`sticky top-0 z-50 transition-all duration-300 ${
          isScrolled 
            ? 'bg-white shadow-lg' 
            : 'bg-white'
        }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
              <img
                src="/logo-ortadogu-ziraat.svg"
                alt="Ortadoğu Ziraat A.Ş."
                className="h-14 w-auto"
                style={{ backgroundColor: 'transparent' }}
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-1">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-2 text-[15px] font-medium rounded-lg transition-all duration-200 ${
                    location.pathname === item.path
                      ? 'text-white bg-gradient-to-r from-[#8AC73E] to-[#4A7C3A] shadow-md'
                      : 'text-gray-700 hover:text-[#8AC73E] hover:bg-gray-50'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMobileMenuOpen && (
            <nav className="lg:hidden py-4 border-t border-gray-200 animate-in slide-in-from-top">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`block px-4 py-3 text-base font-medium rounded-md transition-all ${
                    location.pathname === item.path
                      ? 'text-white bg-gradient-to-r from-[#8AC73E] to-[#4A7C3A]'
                      : 'text-gray-700 hover:text-[#8AC73E] hover:bg-gray-50'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </nav>
          )}
        </div>
      </header>
    </>
  );
};
